import { IonCol, IonContent, IonPage, IonRow, IonImg } from '@ionic/react';
import { FC } from 'react';
import { translation } from '../../models/translation';

const TransactionFailure: FC = () => {

const siteText = translation()


    return (
        <IonPage className='pageContent'>
            <IonContent >
                <IonRow className='ion-text-center sw_sp_lg'>
                    <IonCol offsetSm='2' sizeSm='8'>
                        < IonImg className='home_logo sw_mb_sm' src={`${process.env.PUBLIC_URL}/assets/swissdonations_logo_01.png`}></IonImg>
                        <h1 className='h2'>{siteText.transactionConfirmationFailureTitle}</h1>
                        <p>{siteText.transactionConfirmationFailureBody} </p>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    )
}

export default TransactionFailure;